import React, {useState, useEffect} from 'react'
import Color from '../../../Components/Colors/Color'
import CustomSnackbar from "../../Components/Snackbar/Snackbar"
import { NavLink, useNavigate } from 'react-router-dom';
import '../../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import './AdminNav.css'
import { useLogOutStateContext } from '../../../Contexts/LogOutContext';

const AdminNav = () => {

    const [openDrawer, setOpenDrawer] = useState(false);

    const closeMobileMenu = () => setOpenDrawer(false);

    const {showOverlayLogOut, setShowOverlayLogOut} = useLogOutStateContext();

    const handleOpenOverlay = () =>{
        setShowOverlayLogOut(prevState => ({
            ...prevState,
            overlay: true
        }))
    }

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    return(
        <nav className="admin-nav-container" style={{backgroundColor: Color.secondaryText, color: Color.thirdText}}>
            <div className='admin-nav-container-inside'>
                <div className='admin-nav-logo-container'>
                    <img src='/Images/opc-logo-new-3.png' alt='opc-logo' className='admin-nav-logo' />
                </div>
                <div className='admin-nav-links-container'>
                    <div className='admin-nav-drawer-icon-container' onClick={() => setOpenDrawer(drawer => !drawer)}>
                        <span className='fa-solid fa-bars admin-nav-drawer-icon' style={{color: Color.thirdText}}></span>
                    </div>
                    {/* <div className='admin-nav-account-icon-container'>
                        <span className='fa-regular fa-user admin-nav-icon'></span>
                    </div> */}
                </div>
            </div>
            <div className={`admin-nav-drawer-container ${openDrawer ? '' : 'close'}`} onClick={closeMobileMenu}>
                <div className={`admin-nav-drawer-container-inner ${openDrawer ? '' : 'close'}`} onClick={handleStopPropagation}>
                    <ul className='admin-nav-drawer-list'>
                        <li className='admin-nav-drawer-list-item'>
                            <NavLink
                                to="/admin-dashboard"
                                onClick={closeMobileMenu}
                            > 
                                Products
                            </NavLink>
                        </li>
                        <li className='admin-nav-drawer-list-item'>
                            <NavLink
                                to="/admin-dashboard/announcements"
                                onClick={closeMobileMenu}
                            > 
                                Announcements
                            </NavLink>
                        </li>
                        <li className='admin-nav-drawer-list-item'>
                        <NavLink
                                to="/admin-dashboard/profile"
                                onClick={closeMobileMenu}
                            > 
                                Profile
                            </NavLink>
                        </li> 
                        <li className='admin-nav-drawer-list-item' onClick={handleOpenOverlay}>
                            Log out
                        </li> 
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default AdminNav;